module.exports = __webpack_public_path__ + "img/calander.f66cc8c6.svg";